import React from 'react'
import SvgWrapper from '../SvgWrapper'
import { ICON_SIZE, ICON_VIEWBOX } from './constants'
import type { IconProps } from './types'

const CostCenterIcon: React.FC<IconProps> = ({
  viewBox = ICON_VIEWBOX.medium,
  color = 'currentColor',
  size = ICON_SIZE.medium,
  fillOpacity,
}) => (
  <SvgWrapper aria-label="Cost center" viewBox={viewBox} size={size}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.14286 0C.925309 0 0 1.04671 0 2.25837v1.92345h20V2.25837C20 1.04671 19.0747 0 17.8571 0H2.14286ZM0 13.7417V6h20v7.7417C20 14.9533 19.0747 16 17.8571 16H2.14286C.925309 16 0 14.9533 0 13.7417Zm13.5714-3.92352c-.5917 0-1.0714.48842-1.0714 1.09092 0 .6025.4797 1.0909 1.0714 1.0909h2.1429c.5917 0 1.0714-.4884 1.0714-1.0909s-.4797-1.09092-1.0714-1.09092h-2.1429Z"
      fill={color}
      fillOpacity={fillOpacity}
    />
  </SvgWrapper>
)

export default CostCenterIcon
